import { Injectable } from '@angular/core';
import { ChartFacade } from '@mode/charts/contract';
import { ChartTypes } from '@mode/shared/contract-common';
import { ReportClientService } from '@mode/shared/data-access-webapp';
import { SwitchViewFacade } from '@mode/switch-views/contract';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import * as ReportEditorActions from './report-editor.actions';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ChartSwitchActions } from '@mode/charts/domain';

@Injectable()
export class ReportEditorEffects {
  constructor(
    private actions$: Actions,
    private reportClientService: ReportClientService,
    private switchViewFacade: SwitchViewFacade,
    private chartFacade: ChartFacade
  ) {}

  importDatasetWithChart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ReportEditorActions.importDatasetWithChartFromSearch, ReportEditorActions.importDatasetWithChartFromUrl),
        concatMap((action) =>
          this.reportClientService
            .importDatasetWithChart(
              action.accountId,
              action.reportId,
              action.queryToken,
              action.chartColorPaletteToken,
              action.encoding,
              action.format,
              action.fieldFormats
            )
            .pipe(
              map((response) =>
                this.chartFacade.importDatasetWithChartSuccess(
                  action.accountId,
                  action.reportId,
                  response.switchViewToken,
                  <string>response?.vizToken,
                  action.queryToken,
                  {
                    caption: {
                      text: '',
                      isHidden: true,
                      isTitleHidden: true,
                      position: ChartTypes.ChartCaptionPosition.Bottom,
                    },
                    chartType: 'table',
                    createdAt: new Date().toISOString(),
                    colorPaletteToken: action.chartColorPaletteToken,
                    description: '',
                    encoding: action.encoding,
                    facetSizes: {},
                    fieldColors: {},
                    fieldFormats: action.fieldFormats,
                    format: action.format,
                    isAutoUpdateDisabled: false,
                    switchViewToken: response.switchViewToken,
                    title: '',
                    token: <string>response.vizToken,
                    version: 2,
                  }
                )
              ),
              catchError((error) => of(ReportEditorActions.importDatasetFailure({ error: error.error.message })))
            )
        )
      ),
    { dispatch: false }
  );

  importDatasetSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ReportEditorActions.importDatasetSuccess, ChartSwitchActions.importDatasetWithChartSuccess),
        concatMap((action) =>
          this.reportClientService.loadDataViews(action.accountId, action.reportId, action.switchViewToken).pipe(
            map((response) => {
              this.switchViewFacade.loadImportedDatasetSuccess(
                response.importedDataset,
                response.shareLink,
                response.mostRecentReportRunToken
              );
            })
          )
        )
      ),
    { dispatch: false }
  );
}
